'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getImages = undefined;

var _middleware = require('../../middleware');

var _paths = require('./paths');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

/**
 * getImages
 * 
 * Fetches all images for a specific product. 
 * @param {string} feis_id 
 * @param {string} product_id 
 */
var getImages = exports.getImages = function getImages(feis_id, product_id) {
  return function (dispatch, getState) {

    var images = (0, _paths.imagesPath)(getState(), product_id);

    // prefer the cached version
    if (images) return;

    return dispatch(_defineProperty({
      feis_id: feis_id,
      product_id: product_id

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/feiseanna/' + feis_id + '/products/' + product_id + '/images',
        method: 'GET'
      },
      types: ['GET_IMAGES_START', 'GET_IMAGES', 'GET_IMAGES_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/products/getImages.js
// module id = 237
// module chunks = 0